import { render, staticRenderFns } from "./UserStockWatchingListMobile.vue?vue&type=template&id=0d0e27aa&scoped=true&"
import script from "./UserStockWatchingListMobile.vue?vue&type=script&lang=js&"
export * from "./UserStockWatchingListMobile.vue?vue&type=script&lang=js&"
import style0 from "./UserStockWatchingListMobile.vue?vue&type=style&index=0&id=0d0e27aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0e27aa",
  null
  
)

export default component.exports